export enum ClinicalStatus {
  ACTIVE = 'Active',

  RECURRENCE = 'Recurrence',

  RELAPSE = 'Relapse',

  INACTIVE = 'Inactive',

  REMISSION = 'Remission',

  RESOLVED = 'Resolved',
}
